import request from '@/utils/request';
// 报修限制
export const repairLimit = (data: any) =>
  request({
    url: 'Branch/repairLimit',
    method: 'put',
    data
  });
export const getBranchList = (params: any) =>
  request({
    url: 'Branch/branchList',
    method: 'get',
    params
  });

export const addBranch = (data: any) =>
  request({
    url: 'Branch/branch',
    method: 'post',
    data
  });

export const editBranch = (data: any) =>
  request({
    url: 'Branch/branch',
    method: 'put',
    data
  });

export const delBranch = (data: any) =>
  request({
    url: 'Branch/branch',
    method: 'delete',
    data
  });

export const getBranchServicerList = (params: any) =>
  request({
    url: 'Servicer/servicerList',
    method: 'get',
    params
  });

export const getServicerQrCode = (params: any) =>
  request({
    url: 'Servicer/qrCode',
    method: 'get',
    params
  });

export const delBranchServicer = (data: any) =>
  request({
    url: 'Servicer/Servicer',
    method: 'delete',
    data
  });

export const getBranchAdmin = (params: any) =>
  request({
    url: 'Branch/admin',
    method: 'get',
    params
  });

export const addBracnhAdmin = (data: any) =>
  request({
    url: 'Branch/admin',
    method: 'post',
    data
  });

export const exportBranchInviteQr = (params: any) =>
  request({
    url: 'Branch/batchInviteQr',
    method: 'get',
    params,
    responseType: 'blob'
  });

export const exportBranchCyclcheckQr = (params: any) =>
  request({
    url: 'CycleCheck/exportBranchCompanyQrCode',
    method: 'get',
    params
  });

export const addBrnachServicer = (data: any) =>
  request({
    url: 'Branch/batchServicer',
    method: 'post',
    data
  });
export const delBrnachServicer = (data: any) =>
  request({
    url: 'Branch/batchServicer',
    method: 'DELETE',
    data
  });
export const getBranchOrderList = (params: any) =>
  request({
    url: 'Order/branchOrderList',
    method: 'get',
    params
  });

export const getBranchOrderProgressList = (params: any) =>
  request({
    url: 'Order/branchProgressList',
    method: 'get',
    params
  });

export const getBranchOrderDetail = (params: any) =>
  request({
    url: 'Order/branchOrderDetail',
    method: 'get',
    params
  });

export const getServicerList = (params: any) =>
  request({
    url: 'Branch/servicerList',
    method: 'get',
    params
  });

export const getCustomerList = (params: any) =>
  request({
    url: 'Branch/customerList',
    method: 'get',
    params
  });
  // 批量导入公司
export const importBranch = (data: any) =>
  request({
    url: 'Branch/importBranch',
    method: 'post',
    data
  });

export const getBranchRecordList = (params: any) =>
  request({
    url: 'Branch/dayCycleCheck',
    method: 'get',
    params
  });

export const getBranchExportOrdersCount = (data: any) =>
  request({
    url: 'Branch/exportCusOrder',
    method: 'post',
    data
  });

export const exportBranchOrdersData = (data: any) =>
  request({
    url: 'Branch/exportCusList',
    method: 'post',
    data
  });
export const batchSetRepairTemplate = (data: any) =>
  request({
    url: 'Branch/batchSetRepairTemplate',
    method: 'post',
    data
  });
export const batchDeleteRepairTemplate = (data: any) =>
  request({
    url: 'Branch/batchDeleteRepairTemplate',
    method: 'DELETE',
    data
  });
export const getSyncBranchCompanyBrand = (params: any) =>
  request({
    url: 'Branch/syncBranchCompanyBrand',
    method: 'get',
    params
  });
